const compareIncidents = (first, second) => (first.iconApp || '').localeCompare(second.iconApp || '');
export const groupIncidents = (incidents) => {
    const sorted = [...incidents].sort(compareIncidents);
    let lastIconApp;
    const groups = [];
    sorted.forEach(incident => {
        if (incident.iconApp !== lastIconApp) {
            lastIconApp = incident.iconApp;
            groups.push([]);
        }
        groups[groups.length - 1].push(incident);
    });
    return groups;
};
